import React from 'react';
import { DatePicker, ConfigProvider  } from "tea-component";
import moment from 'moment'

import "moment/locale/zh-cn";
import en_US from "tea-component/es/i18n/locale/en_US";
import zh_CN from "tea-component/es/i18n/locale/zh_CN";


const TimePicker = (props: { [x: string]: any; value: any; onConfirm: any; locale: any;disabledDate: any,disabled:boolean }) => {
  const { value,comKey, onConfirm,locale, className,disabledDate,disabled, ...rest } = props
  return (
    <>
      <ConfigProvider locale={locale ==='en-US' ? en_US : zh_CN}>
        <DatePicker
          // 处理时间筛选器重置无效问题
          key={value+ comKey}
          value={moment(value)}
          disabledDate={disabledDate}
          className={className}
          // clearable
          defaultValue={''}
          onChange={onConfirm}
          disabled={disabled}
          />
      </ConfigProvider>


    </>
  )
}

export default TimePicker
